"use client";

import ChatBot from "@/components/ChatBot/ChatBot";
import RouteChangeHandler from "@/hook/RouteChangeHandler";

export default function ClientEnhancements() {
  return (
    <>
      <RouteChangeHandler />
      <ChatBot />
    </>
  );
}
